import { render, staticRenderFns } from "./IFSourcesUses.vue?vue&type=template&id=d48e0564"
import script from "./IFSourcesUses.vue?vue&type=script&lang=js"
export * from "./IFSourcesUses.vue?vue&type=script&lang=js"
import style0 from "./IFSourcesUses.vue?vue&type=style&index=0&id=d48e0564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports